import React, { createContext, useContext, useState, useEffect } from 'react';

const ReserveContextV2 = createContext();

export const useReservation = () => useContext(ReserveContextV2);

export const ReserveProviderV2 = ({ children }) => {
    const [isReserved, setIsReserved] = useState(false);
    const [tempReserveInfo, setTempReserveInfo] = useState(null);

    useEffect(() => {
        console.log('Reservation status changed:', isReserved);
        if (!isReserved) {
            console.log('Clearing temporary reservation info as reservation is cancelled.');
            setTempReserveInfo(null);
        }
    }, [isReserved]);

    useEffect(() => {
        console.log('Temporary reservation info changed:', tempReserveInfo);
    }, [tempReserveInfo]);

    return (
        <ReserveContextV2.Provider value={{ isReserved, setIsReserved, tempReserveInfo, setTempReserveInfo }}>
            {children}
        </ReserveContextV2.Provider>
    );
};

export default ReserveContextV2;
